export default "__VITE_ASSET__Dz$QwoX1__"